var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00785e",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbd116",
    d: "m25.2 9 3.4 2.5-1.3-4-1.3 4 3.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.3 27.6h-8.5l-.3-.3h8.8l.1.2zm0-2.6a1 1 0 0 0 0-1 7 7 0 0 1-4.6 2h-5.3l.5.6h5q2.6 0 4.4-1.6m-9.1-2-.8.1a6.7 6.7 0 0 0 10 .2 37 37 0 0 0 0-10.5 7 7 0 0 0-1.2 8.9 7 7 0 0 1-.8-7l-.7-1.1a7 7 0 0 0 .5 7.3 8 8 0 0 0-6.1-2.4l.5.7a8 8 0 0 1 5.8 2.4 8 8 0 0 0-8.2-1.2 7 7 0 0 0 7 4.4h-1.3q-2.6 0-4.7-1.8m9.1 7.4H23q2.2.8 4.4.8l.1-.4zm0-2h-7.8l.7.4h7.1l.1-.2zm0 1H21l1.2.6h5.2l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbd116",
    d: "m17.4 14.6 2 2-.5-2.9-1.2 2.6 2.5-1.4zm3-2.7h3L21 10.3l1 2.7 1-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.3 27.6H36l.3-.3h-8.9zm0-2.6a1 1 0 0 1 0-1 7 7 0 0 0 4.7 2h5.3l-.5.6h-5.1q-2.6 0-4.4-1.6m9.2-2 .8.1a6.7 6.7 0 0 1-10 .2 37 37 0 0 1 0-10.5 7 7 0 0 1 1.2 8.9 7 7 0 0 0 .8-7q.5-.5.6-1.1a7 7 0 0 1-.4 7.3 8 8 0 0 1 6-2.4l-.5.7a8 8 0 0 0-5.7 2.4 8 8 0 0 1 8.1-1.2 7 7 0 0 1-6.8 4.4h1.2q2.6 0 4.7-1.8m-9.2 7.4h4.5q-2.3.8-4.5.8zm0-2h7.8l-.6.4h-7.2zm0 1h6.4l-1.2.6h-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbd116",
    d: "m37.3 14.6-2.1 2 .5-2.9 1.2 2.6-2.5-1.4zm-3-2.7h-3l2.3-1.7-.8 2.8-1-2.8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMo);
export default __webpack_public_path__ + "static/media/mo.521fa183376ef215c39d6593b4bc69a1.svg";
export { ForwardRef as ReactComponent };